var _rect, _rect2, _rect3, _rect4, _rect5, _polyline, _polyline2, _polyline3, _polyline4, _polygon, _polygon2, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flag",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 15",
    style: {
      enableBackground: "new 0 0 24 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "#26346C",
    width: 24,
    height: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    fill: "#FFFFFF",
    width: 24,
    height: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 0,
    fill: "#FFFFFF",
    width: 5,
    height: 15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    fill: "#CF152C",
    width: 24,
    height: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 0,
    fill: "#CF152C",
    width: 3,
    height: 15
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "14.5,4.5 21.5,0 24,0 24,1.5 18.5,5 14.5,5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "14.5,10.5 21.5,15 24,15 24,13.5 18.5,10 14.5,10"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "9.5,10.5 2.5,15 0,15 0,13.5 5.5,10 9.5,10"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFFFFF",
    points: "9.5,4.5 2.5,0 0,0 0,1.5 5.5,5 9.5,5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF152C",
    points: "14.5,5 22.5,0 24,0 16,5.001"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF152C",
    points: "9.5,10 1.5,15 0,15 8,10"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF152C",
    points: "18,10 24,14 24,15 16.5,10"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#CF152C",
    points: "6,5 0,1 0,0 7.5,5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.807e251c3c6e734b0ab31f60cc0ec342.svg";
export { ForwardRef as ReactComponent };